export default __webpack_public_path__ + "static/media/my-collection.87266537.svg";